import { render, staticRenderFns } from "./VTaskGroup.vue?vue&type=template&id=87b5ae94&"
import script from "./VTaskGroup.vue?vue&type=script&lang=ts&"
export * from "./VTaskGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports